module.exports = __webpack_public_path__ + "static/media/sign-out-alt.845a1221.svg";